import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import RecommendedExams from './Components/RecommenderRoute/RecommendedExams';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import PacksProvider from './Components/Context/PacksContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function RecommendedExamsRoute() {
    return (
        <UserInfoProvider>
            <PacksProvider>
                <MedicalContextProvider>
                    <div className="RecommendedExamsRoutePage">
                        <div className="RecommendedExamsRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="RecommendedExamsRoute">
                            <RecommendedExams/>
                        </div>
                        {/*<div className="RecommendedExamsRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </PacksProvider>
        </UserInfoProvider>
    );
}

export default RecommendedExamsRoute;